import AppBackgroundColor from '@components/app-background-color/AppBackgroundColor';
import ButtonLink from '@components/button-link/ButtonLink';
import Hero from '@components/hero/Hero';
import { ContentBlock } from '@layouts/ContentBlocks';
import { Link } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeSeoData } from 'config/next-seo.config';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import React from 'react';

import useStyles from './careers.style';

const title = 'Careers with the Home Staging Disruptor Guest House';
const description = 'Interested in home staging? We want to talk. We\'re not just another home staging company, we\'re bringing world class design and décor to home staging.';
const openPositions = [];

function Careers() {
  const { classes, theme } = useStyles();


  return (
    <>
      <AppBackgroundColor backgroundColor="#f6f1f0" />

      <Head>
        <title>
          {title}
        </title>
      </Head>

      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle: title, metaDescription: description })} />

      <ContentBlock
        maxWidth={1365}
        margin={[8, 0]}
      >
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid
            item
            xs={11}
            md={8}
            display="flex"
            alignItems="center"
          >
            <Typography
              variant="h1"
              className={classes.pageTitle}
            >
              Let&apos;s work together
            </Typography>
          </Grid>
        </Grid>

        <Hero
          backgroundColor="#ededed"
          backgroundImage="/images/careers/careers-main.jpg"
          style={{
            backgroundPosition: '50% 70%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        >
        </Hero>
      </ContentBlock>

      <ContentBlock
        maxWidth={1365}
        margin={[0, 0]}
      >
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Typography
              gutterBottom
              variant="h2"
              className={classes.subheaders}
            >
              We&apos;re hiring
            </Typography>

            <Typography
              paragraph
              className={classes.infoText}
              color="textSecondary"
            >
              Are you passionate about making lives easier and the world a more beautiful place? 
              {' '}
              We&apos;d love to meet you. We&apos;re always posting new roles below. 
              {' '}
              If you don&apos;t see a position and still want to chat, send us a note at
              {' '}
              <Link href="mailto:careers@guesthouseshop.com">
                careers@guesthouseshop.com
              </Link>
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            md={5}
            className={classes.guideContainer}
          >
            <Box
              className={classes.guideBubbles}
              style={{ width: 286 }}
            >
              <Typography
                className={classes.guideText}
                color="textSecondary"
              >
                💡 Never stop learning
              </Typography>
            </Box>

            <Box
              className={classes.guideBubbles}
              style={{ width: 187, marginLeft: 'auto', marginTop: theme.spacing(1.2) }}
            >
              <Typography
                className={classes.guideText}
                color="textSecondary"
              >
                🔥 Own it
              </Typography>
            </Box>

            <Box
              className={classes.guideBubbles}
              style={{ width: 333, marginTop: theme.spacing(1.2) }}
            >
              <Typography
                className={classes.guideText}
                color="textSecondary"
              >
                🏃 Run toward problems
              </Typography>
            </Box>

            <Box
              className={classes.guideBubbles}
              style={{ width: 254, marginLeft: 'auto', marginTop: theme.spacing(1.2) }}
            >
              <Typography
                className={classes.guideText}
                color="textSecondary"
              >
                🤝 Win as a team 
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </ContentBlock>

      <ContentBlock
        maxWidth={1365}
        margin={[12, 0]}
      >
        <Grid container>
          {openPositions?.length > 0 &&
          <>
            <Grid
              item
              md={7}
              xs={12}
            >
              <Typography
                gutterBottom
                id="openpositions"
                component="h2"
                variant="h4Alt"

                className={classes.subheaders}
              >
                Open Positions
              </Typography>
            </Grid>
            {' '}
            
          </>
        }
        

          <Grid
            container
            justifyContent="space-between"
            spacing={2}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <Box className={classes.nameYourJob}>
                <Typography style={{ fontSize: 40 }}>
                  📝
                </Typography>

                <Typography
                  variant="h4Alt"
                  style={{ fontSize: 18, marginBottom: theme.spacing(2), marginTop: '12px' }}
                >
                  Account Executive / Market Sales Lead (Colorado)
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  We’re looking for an exceptional team member to lead growth efforts in the Denver/Boulder market for Guest House.
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  Account Executives (“Market Leaders”) are the key to growth for our company, responsible for all aspects of sales and revenue in the region. The right candidate is goal-
                </Typography>

                <Button
                  size="medium"
                  variant="contained"
                  color="secondary"
                  className={classes.openPositions}
                  component={ButtonLink}
                  href="https://builtin.com/job/account-executive-market-sales-lead/4771170"
                  target="_blank"
                >
                  Submit my info
                </Button>
              </Box>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <Box className={classes.nameYourJob}>
                <Typography style={{ fontSize: 40 }}>
                  📝
                </Typography>

                <Typography
                  variant="h4Alt"
                  style={{ fontSize: 18, marginBottom: theme.spacing(2), marginTop: '12px' }}
                >
                  Account Executive / Market Sales Lead (Arizona)
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  We’re looking for an exceptional team member to lead growth efforts in the Phoenix/Scottsdale market for Guest House.
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  Account Executives (“Market Leaders”) are the key to growth for our company, responsible for all aspects of sales and revenue in the region. The right candidate is goal-
                </Typography>

                <Button
                  size="medium"
                  variant="contained"
                  color="secondary"
                  className={classes.openPositions}
                  component={ButtonLink}
                  href="https://www.linkedin.com/jobs/search/?currentJobId=4184965113&f_C=33268172&geoId=92000000&origin=COMPANY_PAGE_JOBS_CLUSTER_EXPANSION&originToLandingJobPostings=4184965113"
                  target="_blank"
                >
                  Submit my info
                </Button>
              </Box>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <Box className={classes.nameYourJob}>
                <Typography style={{ fontSize: 40 }}>
                  📝
                </Typography>

                <Typography
                  variant="h4Alt"
                  style={{ fontSize: 18, marginBottom: theme.spacing(2), marginTop: '12px' }}
                >
                  Staging Stylist – Denver/Boulder
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  Passionate about design and creating stunning spaces in Colorado? 
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  As a Stylist at Guest House, you&apos;ll transform properties into breathtaking, market-ready homes with expertly curated furnishings and decor. If you have an eye for detail, a love for aesthetics, and a knack for making any space shine, we want you on our team!
                </Typography>

                <Button
                  size="medium"
                  variant="contained"
                  color="secondary"
                  className={classes.openPositions}
                  component={ButtonLink}
                  href="mailto:colorado@guesthouseshop.com"
                >
                  Submit my info
                </Button>
              </Box>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <Box className={classes.nameYourJob}>
                <Typography style={{ fontSize: 40 }}>
                  📝
                </Typography>

                <Typography
                  variant="h4Alt"
                  style={{ fontSize: 18, marginBottom: theme.spacing(2), marginTop: '12px' }}
                >
                  Staging Stylist – San Diego/Orange County
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  Passionate about design and creating stunning spaces in Southern California? 
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  As a Stylist at Guest House, you&apos;ll transform properties into breathtaking, market-ready homes with expertly curated furnishings and decor. If you have an eye for detail, a love for aesthetics, and a knack for making any space shine, we want you on our team!
                </Typography>

                <Button
                  size="medium"
                  variant="contained"
                  color="secondary"
                  className={classes.openPositions}
                  component={ButtonLink}
                  href="mailto:california@guesthouseshop.com"
                >
                  Submit my info
                </Button>
              </Box>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <Box className={classes.nameYourJob}>
                <Typography style={{ fontSize: 40 }}>
                  📝
                </Typography>

                <Typography
                  variant="h4Alt"
                  style={{ fontSize: 18, marginBottom: theme.spacing(2), marginTop: '12px' }}
                >
                  Staging Stylist – Phoenix/Scottsdale
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  Passionate about design and creating stunning spaces in Arizona?
                </Typography>

                <Typography style={{ marginBottom: theme.spacing(2) }}>
                  As a Stylist at Guest House, you&apos;ll transform properties into breathtaking, market-ready homes with expertly curated furnishings and decor. If you have an eye for detail, a love for aesthetics, and a knack for making any space shine, we want you on our team!
                </Typography>

                <Button
                  size="medium"
                  variant="contained"
                  color="secondary"
                  className={classes.openPositions}
                  component={ButtonLink}
                  href="mailto:arizona@guesthouseshop.com"
                >
                  Submit my info
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </ContentBlock>
    </>
  );
}

export default Careers;
